export function sanitizePhoneNumber(value) {
  return value.replace(/\D/g, '').slice(0, 10)
}

const checkoutRequestStatusLabels = {
  pending: 'Pendiente',
  contacted: 'Contactado',
  preparing: 'En preparación',
  completed: 'Completada',
  cancelled: 'Cancelada'
}

export function formatCheckoutRequestStatus(status) {
  return checkoutRequestStatusLabels[status] || status
}

export function formatShopDateTime(value) {
  if (!value) return ''

  return new Intl.DateTimeFormat('es-MX', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date(value))
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
  }).format(Number(value || 0))
}
